





















































import { Component, Prop, Vue } from "vue-property-decorator";
import { RefuelingHistoryEntry } from "@/types/refuelingEvent";

@Component
export default class RefuelingEntry extends Vue {
    name = "RefuelingEntry";

    @Prop() refuelingEntry!: RefuelingHistoryEntry;
    @Prop() previousRefuelingEntry!: RefuelingHistoryEntry;

    get total(): number {
        return this.refuelingEntry.liters * this.refuelingEntry.pricePerLiter;
    }

    get consumption(): number {
        if (!this.previousRefuelingEntry)
            return 0;
        const kilometers = this.refuelingEntry.mileage - this.previousRefuelingEntry.mileage;
        return (this.refuelingEntry.liters / kilometers)*100.0;
    }

    get formattedConsumption(): string {
        return new Intl.NumberFormat("de", {maximumFractionDigits:2}).format(this.consumption);
    }

    get priceColor(): string {
        if (this.refuelingEntry.pricePerLiter < 1.1) {
            return "success";
        }
        if (this.refuelingEntry.pricePerLiter > 1.35) {
            return "error";
        }
        return "";
    }

    get consumptionClass(): string {
        if (this.consumption < 7) {
            return "green--text";
        }
        if (this.consumption > 8) {
            return "red--text"
        }
        return "";
    }

    get kilometers() : number {
        if (!this.previousRefuelingEntry)
            return 800;
        return this.refuelingEntry.mileage - this.previousRefuelingEntry.mileage;
    }

    get pricePerLiterDelta(): number {
        if (!this.previousRefuelingEntry)
            return this.refuelingEntry.pricePerLiter;
        return this.refuelingEntry.pricePerLiter - this.previousRefuelingEntry.pricePerLiter;
    }

    get elapsedDays(): number {
        if (!this.previousRefuelingEntry)
            return 0;
        const timeDifference = this.refuelingEntry.date.getTime() - this.previousRefuelingEntry.date.getTime();
        return Math.round((timeDifference / (1000 * 3600 * 24)));
    }
    
    get user(): string {
        return this.refuelingEntry.user;
    }
    
    get userInitial(): string | null {
        if (this.user){
            return this.user[0].toUpperCase();
        }
        return null;
    }
}
